import { ShadowToken } from '../../services/theme-model/shadows'

export function addAlphaToColor(hexColor: string, alpha: number): string {
  const hexAlpha = Math.round(Math.min(Math.max(alpha || 1, 0), 1) * 255)
  return hexColor + hexAlpha.toString(16).toUpperCase()
}

export function getShadowStyles(shadow: ShadowToken, hexColor: string): string {
  const { x, y, blurRadius, spread, color } = shadow
  const { alpha } = color
  return `${x}px ${y}px ${blurRadius}px ${spread}px ${addAlphaToColor(hexColor, alpha as number)}`
}
